module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20212.1e5a9120.jpg";